var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box profile-card-2" }, [
    _vm._m(0),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "start_up_data" }, [
          _vm._v(_vm._s(_vm.startup.name)),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "start_up_line" }),
    _c(
      "div",
      {
        staticClass: "row",
        staticStyle: { "padding-top": "30px", "padding-bottom": "20px" },
      },
      [
        _c(
          "div",
          {
            staticClass: "col-sm-6",
            staticStyle: {
              "text-align": "left",
              "margin-top": "-10px",
              "padding-top": "10px",
            },
          },
          [
            _c("span", { staticClass: "start_up_label" }, [
              _vm._v("STARTUP website"),
            ]),
            _c("div", { staticClass: "start_up_data" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.startup.website == null
                      ? ""
                      : _vm.startup.website.length > 30
                      ? _vm.startup.website.slice(0, 30) + "..."
                      : _vm.startup.website
                  ) +
                  "\n      "
              ),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "col-sm-6",
            staticStyle: {
              "text-align": "left",
              "border-left": "1px solid #e4e5e7",
              "margin-top": "-10px",
              "margin-left": "-20px",
              "padding-left": "20px",
              "padding-top": "10px",
            },
          },
          [
            _c("span", { staticClass: "start_up_label" }, [
              _vm._v("startup location"),
            ]),
            _c("div", { staticClass: "start_up_data" }, [
              _vm._v(_vm._s(_vm.startup.location)),
            ]),
          ]
        ),
      ]
    ),
    _c("div", { staticClass: "start_up_line" }),
    _c(
      "div",
      {
        staticClass: "row",
        staticStyle: { "padding-top": "30px", "min-height": "143px" },
      },
      [
        _c(
          "div",
          {
            staticClass: "col-sm-12",
            staticStyle: {
              "text-align": "left",
              "margin-top": "-10px",
              "padding-top": "10px",
            },
          },
          [
            _c("span", { staticClass: "start_up_label" }, [
              _vm._v("startup BIO"),
            ]),
            _c("div", { staticClass: "start_up_data" }, [
              _vm._v(
                "\n        " + _vm._s(_vm.startup.description) + "\n      "
              ),
            ]),
          ]
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "modal",
        attrs: {
          id: "editStartUpInfo2",
          tabindex: "-1",
          "aria-labelledby": "editStartUpInfoLabel",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", staticStyle: { width: "450px" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(1),
              _c("form", { on: { submit: _vm.editStartUpInfo2 } }, [
                _c(
                  "div",
                  {
                    staticClass: "modal-body",
                    staticStyle: { padding: "20px", "padding-top": "50px" },
                  },
                  [
                    _c("span", { staticClass: "modal_label" }, [
                      _vm._v("Edit startup name, website, location and bio."),
                    ]),
                    _c("br"),
                    _c("br"),
                    _c("span", { staticClass: "modal_label" }, [
                      _vm._v("Startup name"),
                    ]),
                    _c("input", {
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        name: "name",
                        id: "name",
                        placeholder: "name",
                        required: "",
                      },
                      domProps: { value: "" + _vm.startup.name },
                      on: { keyup: _vm.updateData },
                    }),
                    _c("span", { staticClass: "modal_label" }, [
                      _vm._v("Startup website"),
                    ]),
                    _c("input", {
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        name: "website",
                        id: "website",
                        placeholder: "http://",
                        required: "",
                      },
                      domProps: {
                        value:
                          "" +
                          (_vm.startup.website == null
                            ? ""
                            : _vm.startup.website),
                      },
                      on: { keyup: _vm.updateData },
                    }),
                    _c("span", { staticClass: "modal_label" }, [
                      _vm._v("Startup location"),
                    ]),
                    _c("input", {
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        name: "location",
                        id: "location",
                        placeholder: "location",
                        required: "",
                      },
                      domProps: {
                        value:
                          "" +
                          (_vm.startup.location == null
                            ? ""
                            : _vm.startup.location),
                      },
                      on: { keyup: _vm.updateData },
                    }),
                    _c("span", { staticClass: "modal_label" }, [
                      _vm._v("Startup bio"),
                    ]),
                    _c("textarea", {
                      staticClass: "form-control",
                      staticStyle: { height: "70px" },
                      attrs: {
                        name: "bio",
                        id: "bio",
                        placeholder: "Biodata",
                        required: "",
                      },
                      domProps: { value: "" + _vm.startup.description },
                      on: { keyup: _vm.updateData },
                    }),
                  ]
                ),
                _c("div", { staticClass: "modal-footer" }, [
                  _vm.isUpdateStartUp
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            right: "0",
                            "margin-top": "0%",
                            "text-align": "center",
                          },
                          attrs: { id: "loaderCal" },
                        },
                        [
                          _c("v-progress-circular", {
                            attrs: {
                              size: 30,
                              color: "primary",
                              indeterminate: "",
                            },
                          }),
                          _vm._v(
                            "\n              " +
                              _vm._s("updating startup...") +
                              "\n            "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.isUpdateStartUp
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-light lightBorder p-3",
                          attrs: { type: "button", "data-bs-dismiss": "modal" },
                        },
                        [_vm._v("\n              Cancel\n            ")]
                      )
                    : _vm._e(),
                  !_vm.isUpdateStartUp
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary p-3",
                          attrs: { type: "submit" },
                        },
                        [_vm._v("\n              Update\n            ")]
                      )
                    : _vm._e(),
                ]),
              ]),
            ]),
          ]
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "modal",
        attrs: {
          id: "errorModalStartUp",
          tabindex: "-1",
          "aria-labelledby": "errorModalLabel",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", staticStyle: { width: "450px" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(2),
              _c(
                "div",
                {
                  staticClass: "modal-body",
                  staticStyle: { "text-align": "center" },
                },
                [
                  _c("br"),
                  _c("img", {
                    staticStyle: { "margin-top": "30px", width: "150px" },
                    attrs: { src: "/img/cancel.png" },
                  }),
                  _c("br"),
                  _c("br"),
                  _c("p", { staticStyle: { "margin-top": "30px" } }, [
                    _vm._v(
                      "\n            Error detected while updating startup info\n          "
                    ),
                  ]),
                  _c("code", [_vm._v(_vm._s(this.starupInfoUpdateError))]),
                  _c("br"),
                  _c("br"),
                ]
              ),
              _vm._m(3),
            ]),
          ]
        ),
      ]
    ),
    _vm._m(4),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-6", staticStyle: { "text-align": "left" } },
        [
          _c("span", { staticClass: "start_up_label" }, [
            _vm._v("STARTUP NAME"),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "col-6",
          staticStyle: { "text-align": "right" },
          attrs: {
            "data-bs-toggle": "modal",
            "data-bs-target": "#editStartUpInfo2",
          },
        },
        [_c("span", { staticClass: "start_up_edit" }, [_vm._v("Edit")])]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("Edit Startup Info")]),
      _c("button", {
        staticClass: "btn-close",
        attrs: {
          type: "button",
          "data-bs-dismiss": "modal",
          "aria-label": "Close",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("ERROR DETECTED")]),
      _c("button", {
        staticClass: "btn-close",
        attrs: {
          type: "button",
          "data-bs-dismiss": "modal",
          "aria-label": "Close",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-light lightBorder",
          attrs: { type: "button", "data-bs-dismiss": "modal" },
        },
        [_vm._v("\n            Close\n          ")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "modal",
        attrs: {
          id: "successChangeRequestModalStartUp",
          tabindex: "-1",
          "aria-labelledby": "successChangeRequestModalLabel",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", staticStyle: { width: "450px" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v("Startup Info Updated"),
                ]),
                _c("button", {
                  staticClass: "btn-close",
                  attrs: {
                    type: "button",
                    "data-bs-dismiss": "modal",
                    "aria-label": "Close",
                  },
                }),
              ]),
              _c(
                "div",
                {
                  staticClass: "modal-body",
                  staticStyle: { "text-align": "center" },
                },
                [
                  _c("br"),
                  _c("img", {
                    staticStyle: { "margin-top": "30px", width: "150px" },
                    attrs: { src: "/img/marked.svg" },
                  }),
                  _c("br"),
                  _c("br"),
                  _c("p", { staticStyle: { "margin-top": "30px" } }, [
                    _vm._v(
                      "\n            Starup info record updated successfully\n          "
                    ),
                  ]),
                  _c("br"),
                  _c("br"),
                ]
              ),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-light lightBorder",
                    attrs: { type: "button", "data-bs-dismiss": "modal" },
                  },
                  [_vm._v("\n            Close\n          ")]
                ),
              ]),
            ]),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }